import script from "./PatientFAQBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientFAQBoard.vue?vue&type=script&setup=true&lang=ts"

import "./PatientFAQBoard.vue?vue&type=style&index=0&id=65ceac06&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65ceac06"]])

export default __exports__